import FinalSettlementBaseHeader from './FinalSettlementBaseHeader';
import XButton from './common/XButton';

const FinalSettlementHeader = ({
    showSettleAllView,
    onSettleAllClick,
    onCancel,
    onSave,
    isLoading
}) => {
    return (
        <FinalSettlementBaseHeader
            rightContent={
                showSettleAllView ? (
                    <>
                        <XButton
                            variant="outlinePrimary"
                            onClick={onCancel}
                            className="bg-white! text-primary! border-white! hover:bg-primary! hover:text-white!"
                        >
                            Cancel
                        </XButton>
                        <XButton onClick={onSave}>
                            Done
                        </XButton>
                    </>
                ) : (
                    <XButton variant="outlineOnPrimary" onClick={onSettleAllClick} loading={isLoading}>
                        Settle All Cases
                    </XButton>
                )
            }
            showSettleAllView={showSettleAllView}
        />
    );
};

export default FinalSettlementHeader;